import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import { allowedExchangeTypesOptions, allowedExchangeTypesValues } from './constants'

export const filterAllowedExchangeTypesOptions = (allowedPreferences, allowsUnifiedFlow, allowsInstantTransactions) => {
  let options = allowedExchangeTypesOptions

  if (!allowedPreferences.includes(preferences.allowsExchanges)) {
    options = options.filter(
      o =>
        o.value !== allowedExchangeTypesValues.exchange &&
        o.value !== allowedExchangeTypesValues.exchangeAndInstantExchange
    )
  }

  if (!allowedPreferences.includes(preferences.allowsInstantExchanges) || !allowsInstantTransactions) {
    options = options.filter(
      o =>
        o.value !== allowedExchangeTypesValues.instantExchange &&
        o.value !== allowedExchangeTypesValues.exchangeAndInstantExchange
    )
  }

  if (allowsUnifiedFlow) {
    options = options.filter(o => o.value !== allowedExchangeTypesValues.instantExchange)
  }

  return options
}

export const getAllowedExchangeTypesValue = (allowExchanges, allowInstantExchanges, allowsInstantTransactions) => {
  if (allowExchanges && allowInstantExchanges) {
    return allowedExchangeTypesValues.exchangeAndInstantExchange
  }

  if (allowExchanges) {
    return allowedExchangeTypesValues.exchange
  }

  if (allowInstantExchanges && allowsInstantTransactions) {
    return allowedExchangeTypesValues.instantExchange
  }

  return null
}
